/**
 * 各种环境的设置
 * 针对：开发环境（debug环境），测试环境，生产环境，单元测式环境[暂定]，mock环境[暂定]
 * 应对一些需要缓存在客户端的数据
 *
 * @since 1.0.0
 * @version 1.0.0
 */

// 开发环境
export const IS_DEV = JSON.parse(localStorage.getItem('IS_DEV')) || process.env.VUE_APP_SERVER_ENV === 'development'

// 测试环境
export const IS_TEST = process.env.VUE_APP_SERVER_ENV === 'test'

// 预发环境
export const IS_RELEASE = process.env.VUE_APP_SERVER_ENV === 'release'

// 生产环境
export const IS_PROD = process.env.VUE_APP_SERVER_ENV === 'production'
